import $ from 'jquery';

export const daumPostHelper = (log) => {
  /* global daum */

  const daumZipFinder = function ($finder, $sheet) {
    let currentScrollPosition = 0;
    return {
      prevPosition: function () {
        return currentScrollPosition;
      },
      open: function () {
        currentScrollPosition = Math.max(document.body.scrollTop, document.documentElement.scrollTop);

        $sheet.hide();
        $finder.show();

        return this;
      },
      close: function () {
        $sheet.show();
        $finder.hide();
      },
      run: function ({ codeFinder, resizer }) {
        new daum.Postcode({
          oncomplete: codeFinder,
          onresize: resizer,
          width: '100%',
          height: '100%',
        }).embed($finder[0]);
      },
    };
  };

  $('#daum_post_plugin').each((index, el) => {
    log('postal code finder count:', index + 1);

    const $form = $(el);
    const $finder = $form.find('.postal-code-wrap');
    const $sheet = $('section.enrollment');
    const $holder = {
      zipCode: $form.find('input[name=zipCode]'),
      postalCode: $form.find('input[name=postalCode]'),
      addressArea: $form.find('input[name=address]'),
      addressExtra: $form.find('input[name=address_extra]'),
    };

    const finder = daumZipFinder($finder, $sheet);
    const handler = {
      resizer: function (size) {
        $finder[0].style.height = size.height + 'px';
      },
      codeFinder: function (data) {
        log(data);

        let address = '';

        if (data.userSelectedType === 'R') {
          let addressSub = '';
          address = data.roadAddress;

          if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
            addressSub += data.bname;
          }
          if (data.buildingName !== '' && data.apartment === 'Y') {
            addressSub += addressSub !== '' ? ', ' + data.buildingName : data.buildingName;
          }
          if (addressSub !== '') {
            address += ' (' + addressSub + ')';
          }
        } else {
          address = data.jibunAddress;
        }

        $holder.zipCode.val(data.zonecode);
        $holder.postalCode.val(data.zonecode);
        $holder.addressArea.val(address);

        $finder.hide();

        setTimeout(() => {
          $sheet.show();
          $holder.addressExtra.focus();

          $holder.postalCode.val() && $holder.postalCode.parents().removeClass('fail');
          $holder.addressArea.val() && $holder.addressArea.parents().removeClass('fail');

          document.body.scrollTop = finder.prevPosition();
        }, 100);
      },
    };

    $form.on('click', '.open-finder', function (e) {
      e.preventDefault();
      if ($finder.length && daum) {
        log('daum postal code finder can manipulate DOM');
        finder.open().run({ codeFinder: handler.codeFinder, resizer: handler.resizer });
      }
    });

    $form.on('click', '.close-finder', function (e) {
      finder.close();
    });
  });
};
